import { useEffect } from 'react';

import {
  PageValues,
  usePageContext,
} from '@providers/PageMetaProvider/model/PageContext';
import usePageTitle from '@hooks/usePageTitle/usePageTitle';
import UseCaseGroupTable from '@features/admin-use-case-group/containers/UseCaseGroupTable';

const pageValues: PageValues = {
  title: 'Use Case Group',
};

function UseCaseGroupPage() {
  usePageTitle('ZlaytAI - Use Case Group');
  const { setValues } = usePageContext();

  useEffect(() => {
    if (setValues) {
      setValues((prev) => ({
        ...prev,
        ...pageValues,
      }));
    }
  }, []);

  return <UseCaseGroupTable />;
}

export default UseCaseGroupPage;
